<ion-grid *ngIf="parentFormGroup" [formGroup]="parentFormGroup">
    <ion-row>
        <app-form-field *ngIf="labelControl" label="Libellé">
            <ion-input formControlName="label" style="text-align: left; border-bottom: 2px solid rgb(230, 230, 230);"
                       type="text"></ion-input>
        </app-form-field>
        <app-form-field *ngIf="categoryControl" [required]="true" label="Catégorie">
            <app-lov-value-select-filter [parentFormGroup]="parentFormGroup" lovListName="DOCUMENT_TYPE"
                                          parentFormControlName="categoryValue"
                                          style="width: 100%;"></app-lov-value-select-filter>
        </app-form-field>
        <app-form-field [required]="true" label="Format">
            <app-document-formats-select-filter [parentFormGroup]="parentFormGroup" parentFormControlName="formatValue"
                                                style="width: 100%;"></app-document-formats-select-filter>
        </app-form-field>
        <app-form-field [required]="true" label="Fichier" size="12">
            <app-file-upload #fileUpload [maxFileCount]="1"></app-file-upload>
        </app-form-field>
    </ion-row>
</ion-grid>
